import React from 'react'
import MyProfileUploadDocumentationStatus from "./myProfileUploadDocumentationStatus";
import { translateText, translateTextHtml } from "../getTranslationsMyProfileUploadDocumentation";

const IconError = require('assets/images/icon-error.svg')

export const MyProfileUploadDocumentationError = () => (
    <MyProfileUploadDocumentationStatus
        icon={IconError}
        title={translateText('errorTitle')}
        text={translateTextHtml('errorBody')}
        status={"error"}
    />
)
